import { SRE } from '../api/pushGenie';

export const OLD_RESTRICTIONS: {
    key: SRE;
    title: string;
    isHidden?: boolean;
}[] = [
    {
        key: SRE.DEFAULT,
        title: 'Default',
        isHidden: true,
    },
    {
        key: SRE.ALL_PT,
        title: 'Access to All Patients page',
    },
    {
        key: SRE.START_VISIT,
        title: 'Ability to Start a Visit',
    },
    {
        key: SRE.PAY_DASH,
        title: 'Access to Payment Dashboard Page',
    },
    {
        key: SRE.DOWNLOAD_PATIENT_EXCEL,
        title: 'Access to Download Patient Database Excel',
    },
    {
        key: SRE.PAY_DASH_BEYOND_TODAY,
        title: 'Access to Payment Dashboard Page beyond today',
    },
    {
        key: SRE.EDIT_RECEIPT,
        title: 'Ability to Edit Receipt',
    },
];
